import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import s from 'components/templates/hero/hero.sss';

export default class Hero extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(evt) {
		evt.preventDefault();
		smoothScrollTo(document.body, 500, 500);
	}
	render({ data, isDesktop, active }) {
		let {
			id,
			src,
			title,
			subtitle
		} = data;

		// src = isDesktop ? src.desktop : src.mobile;
		// const type = src.includes('.mp4') ? 'video' : 'image';
		// const asset = (
		// 	type === 'video' ? (
		// 		<video class={s.asset} src={src} />
		// 	) : (
		// 		<img class={s.asset} src={src} />
		// 	)
		// )
		return (
			<div class={joinClasses(s.wrapper, active && s.active)} id='hero' data-section-observed>
				<div class={s.txtContainer}>
					<h1 class={s.title}>{title}</h1>
					<h2 class={s.subtitle}>{subtitle}</h2>
				</div>
				<button class={s.scroll} onClick={this.handleClick}/>
			</div>
		);
	}

}
